import moment from 'moment';

function ManageInventoryCtrl($scope, $state, $stateParams, userPreferencesService) { //eslint-disable-line
  _initScope();

  function _initScope() {
    $scope.currentDateUTC = $stateParams.date ? moment.utc(parseInt($stateParams.date, 10)) : moment.utc();

    userPreferencesService.setManagePage('INVENTORY');
  }
}

ManageInventoryCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'userPreferencesService'
];

export default ManageInventoryCtrl;



// WEBPACK FOOTER //
// ./src/components/manageInventory/manageInventoryCtrl.js